import { Locale } from 'modules/i18n';

export const pageWithBillingTabsTr = {
  [Locale.en]: {
    billing: 'Billing',
    usage: 'Usage',
    plans: 'Service plans',
  },
};
